import { NUCLEUS_VAULTS } from '@/constants/nucleus-vaults';
import { QueryKey, STALE_TIME_VERY_SHORT } from '@/constants/shared';
import { nucleusClient } from '@/network/clients/nucleus';
import { useQuery } from '@tanstack/react-query';
import { useAccount } from 'wagmi';

export const useVaultPortfolioData = () => {
  const { address } = useAccount();
  const {
    data,
    isLoading: isLoadingVaultPortfolioData,
    refetch,
  } = useQuery({
    queryKey: [QueryKey.VaultPositions, address],
    queryFn: async () => {
      if (!address) return null;
      const vaultPortfolioData = await nucleusClient.getPortfolio({ userAddress: address });
      const nucleusVaultOnlyPortfolioBalanceUSD = NUCLEUS_VAULTS.reduce((total, vault) => {
        const vaultBalanceUsd = vaultPortfolioData?.vaults?.[vault.vaultAddress.toLowerCase()]?.total_value_in_usd ?? 0;
        return total + vaultBalanceUsd;
      }, 0);
      return {
        nucleusVaultOnlyPortfolioBalanceUSD,
        vaultPortfolioData,
      };
    },
    refetchInterval: STALE_TIME_VERY_SHORT,
  });
  const { vaultPortfolioData, nucleusVaultOnlyPortfolioBalanceUSD = 0 } = data ?? {};
  return {
    vaultPortfolioData,
    nucleusVaultOnlyPortfolioBalanceUSD,
    isLoadingVaultPortfolioData,
    refetchVaultPortfolioData: refetch,
  };
};
